export const SET_TICKETS_LIST = 'SET_TICKETS_LIST';
export const SET_TICKET_DATA = 'SET_TICKETS_DATA';
export const REMOVE_TICKET_DATA = 'REMOVE_TICKET_DATA';
export const CURRENT_PAGE = 'CURRENT_PAGE';
export const SET_TOTAL_RESOURCES = 'SET_TOTAL_RESOURCES';
export const LIMIT_OPTIONS = 'LIMIT_OPTIONS';
export const LIMIT = 'LIMIT';
export const LOADING_DATA = 'LOADING_DATA';
export const ADD_NEW_TICKET_TO_LIST = 'ADD_NEW_TICKET_TO_LIST';
export const ADD_NEW_RESOURCE_TO_COUNT = 'ADD_NEW_RESOURCE_TO_COUNT';
export const SET_NEW_TICKET_ID = 'SET_NEW_TICKET_ID';
export const SET_TICKET_MESSAGES = 'SET_TICKET_MESSAGES';
export const CLEAN_TICKET_MESSAGES = 'CLEAN_TICKET_MESSAGES';
export const ADD_TO_MESSAGES_LIST = 'ADD_TO_MESSAGES_LIST';
export const ENABLE_TICKETS_NOTIFICATIONS = 'ENABLE_TICKETS_NOTIFICATIONS';
export const DISABLE_TICKETS_NOTIFICATIONS = 'DISABLE_TICKETS_NOTIFICATIONS';
